export const SCROLL_FADE_HEIGHT = 40;
